<template>
  <div>
    <textarea
      v-if="isTextarea"
      v-model="model"
      class="form-input"
      :class="inputClass"
      :cols="cols"
      :rows="rows"
      :placeholder="placeholderStr"
      :required="required"
    />
    <input
      v-else
      type="text"
      v-model="model"
      class="form-input"
      :class="inputClass"
      :placeholder="placeholderStr"
      :required="required"
    />
    <input-error-common :showError="showError" :errorMsg="errorMessage.script" />
  </div>
</template>

<script>
  import InputErrorCommon from 'core/components/InputErrorCommon/InputErrorCommon'
  import he from 'he'

  export default {
    name: 'form-input-html-encode',
    components: {
      InputErrorCommon
    },
    props: {
      value: {},
      placeholderStr: () => (''),
      showError: () => (false),
      isTextarea: () => (false),
      cols: () => (''),
      rows: () => (''),
      inputClass: () => (''),
      required: () => ('')
    },
    data () {
      return {
        placeholder: this.placeholderStr || this.$t('inputPlaceholders.htmlEncode'),
        errorMessage: {
          script: this.$t('errorMessages.inputErrors.invalidTags')
        }
      }
    },
    computed: {
      model: {
        get () {
          const valueDecoded = he.decode(this.value || '')
          return valueDecoded
        },
        set (value) {
          const valueEncoded = he.encode(value)
          this.$nextTick(() => {
            this.$emit('input', valueEncoded)
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';
  @import '../form-field-default.scss';

  .form-input {
    @include form-field-default;
    border: 1px solid #eee;

    &:focus {
      border-color: rgba(#000, .15);
    }
  }
</style>
